import { render, staticRenderFns } from "./CampuForm.vue?vue&type=template&id=64cf3258&"
import script from "./CampuForm.vue?vue&type=script&lang=js&"
export * from "./CampuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports